<template>
  <b-modal
    id="car-edit-modal"
    ref="modal"
    :hide-footer="true"
    @hidden="closeModal"
    @show="onOpen"
  >
    <template v-slot:modal-title>
      {{ modalName }}
    </template>

    <b-form
      @submit.stop.prevent="onSubmit"
    >
      <b-row>
        <b-col cols="12">
          <b-form-group
            id="input-group-driver"
            label="Driver"
            label-for="input-driver"
            description="Start typing to see drivers from the list"
          >
            <multiselect
              v-model="selectedDriver"
              placeholder="Drivers"
              :options="drivers"
              :custom-label="fullName"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-3"
            label="Car Registration Number"
            label-for="input-3"
          >
            <b-input
              id="input-reg"
              v-model="$v.form.car.registrationNumber.$model"
              type="text"
              :state="validateState('car.registrationNumber')"
              aria-describedby="input-reg-live-feedback"
            />
            <b-form-invalid-feedback id="input-reg-live-feedback">
              Car registration number is required
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-capacity"
            label="Capacity"
            label-for="input-capacity"
          >
            <b-input
              id="input-capacity"
              v-model.number="$v.form.car.capacity.$model"
              type="number"
              :state="validateState('car.capacity')"
              aria-describedby="input-capacity-live-feedback"
            />
            <b-form-invalid-feedback id="input-capacity-live-feedback">
              Please enter a number above 0
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <multiselect
            v-model="form.car.carType"
            placeholder="Car Type"
            :options="carTypes"
            :searchable="false"
            :allow-empty="false"
            select-label="✓"
            deselect-label="✗"
            selected-label=""
          >
            <template
              slot="option"
              slot-scope="props"
            >
              <div class="d-flex">
                <div
                  class="car-type"
                  :style="{'background':props.option.colourCode}"
                />
                <span>{{ props.option.type }}</span>
              </div>
            </template>
            <template
              slot="singleLabel"
              slot-scope="{ option }"
            >
              <div class="d-flex">
                <div
                  class="car-type van"
                  :style="{'background':option.colourCode}"
                />
                <span>{{ option.type }}</span>
              </div>
            </template>
          </multiselect>
        </b-col>
        <b-col class="d-flex align-items-center">
          <b-form-group
            id="input-group-6"
            class="mb-1"
          >
            <b-form-checkbox
              v-model="form.car.isWorking"
              size="md"
              class="flex-shrink-0"
            >
              Working?
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end mt-2">
        <b-button
          type="submit"
          variant="primary"
        >
          Save
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
  import {required, between} from "vuelidate/lib/validators";
  import validateStateMixin from "../mixins/validateStateMixin";
  import Multiselect from 'vue-multiselect'
  import {mapGetters} from "vuex";

  const phoneValidation = (value) => /^\+[1-9]\d{1,14}$/.test(value)

  export default {
    name: "CarModal",
    computed: {
      ...mapGetters(['selectedHeaderEvent'])
    },
    components: {Multiselect},
    mixins: [validateStateMixin],
    props: ['open','value'],
    data() {
      return {
        form: {
          car: {
            driverId: '',
            capacity: 0,
            isWorking: false,
            registrationNumber: '',
            eventId: '',
            carTypeId: '',
            carType: null,
          },
        },
        drivers: [],
        selectedDriver: null,
        show: true,
        modalName: "New Car",
        carTypes: [],
      };
    },
    watch: {
      open: function () {
        if (this.open) {
          this.$refs['modal'].show()
        } else {
          this.$refs['modal'].hide()
        }
      }
    },
    validations: {
      form: {
        car: {
          capacity: {
            required,
            between: between(1, 999)
          },
          registrationNumber: {
            required
          },
        }
      }
    },
    methods: {
      async onSubmit(evt) {
        var vm = this;
        evt.preventDefault();
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          return;
        }
        try {
          this.form.car.driverId = this.selectedDriver.id;
          this.form.car.eventId = this.selectedHeaderEvent;
          this.form.car.carTypeId = this.form.car.carType.id;
          this.form.car.carType = undefined;
          await this.$http.put(`cars/${this.value.id}`, this.form.car);
        } catch (error) {
          this.handleErrorResponse(error);
        }
        this.closeModal();
      },
      async onOpen(){
        try {
          let carTypesResponse = await this.$http.get('/cartypes');
          let driversResponse = await this.$http.get('/drivers?searches[hidden]=false&limit=1000');
          this.carTypes = carTypesResponse.data;
          this.form.car.carType = this.carTypes.filter(ct=>ct.id === this.value.carTypeId)[0];
          this.drivers = driversResponse.data.items;
          this.selectedDriver = this.drivers.filter(d=>d.id === this.value.driverId)[0];
          this.form.car.capacity = this.value.capacity;
          this.form.car.isWorking = this.value.isWorking;
          this.form.car.registrationNumber = this.value.registrationNumber;
          this.$v.$reset();
        } catch (error) {
          this.handleErrorResponse(error);
        }
      },
      fullName(item) {
        return `${item.firstName} ${item.lastName}`
      },
      closeModal() {
        this.$emit('modal-closed')
      },
    }
  }
  ;
</script>

<style lang="scss" scoped>
  .car-type {
    margin-right: 8px;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50px;
    border: solid 1px rgba(0, 0, 0, 0.125);
  }

  .cars-dropdown /deep/ .dropdown-menu .dropdown-item {
    display: flex;
    align-items: center;

    .car-msg-status {
      margin-top: 0px;
      margin-right: 6px;
    }
  }

  .cars-dropdown /deep/ .dropdown-menu {
    width: 100%;
  }
</style>
